import React, {FC} from "react"
import {RadialBarChart, RadialBar} from "recharts"

import {Label} from "@irati/ui/src/Typography"
import theme from "@irati/ui/src/global/theme"

import {Percentage, RadialWrapper} from "./styled"

const RadialPercentage: FC = ({value, small}) => {
  const buildData = () => {
    return [
      {
        uv: 100,
        fill: theme.colors.greys.white
      },
      {
        uv: value,
        fill: theme.colors.utility.ink
      }
    ]
  }
  const roundedValue = Math.round(value)
  const size = small ? 111 : 148

  return (
    <RadialWrapper>
      <RadialBarChart width={size} height={size} innerRadius="80%" outerRadius="100%" data={buildData()} startAngle={90} endAngle={-270}>
        <RadialBar background clockWise dataKey="uv" cornerRadius={20} />
      </RadialBarChart>
      <Percentage length={roundedValue.toString().length} small={small}>
        <Label>{roundedValue}</Label>%
      </Percentage>
    </RadialWrapper>
  )
}

export default RadialPercentage
